// extracted by mini-css-extract-plugin
export default {"errorBanner":"ErrorBanner-module__errorBanner--uXkz4"};